import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useModuloMiniTesteRespostaService() {
  const { authenticatedFetch } = useApi();

  const criarModuloMiniTesteResposta = async (dados) => {
    const response = await authenticatedFetch(URLS.CREATE_MODULO_MINI_TESTE_RESPOSTA, {
      method: 'POST',
      body: JSON.stringify(dados),
    });
    return response.json();
  };

  const atualizarModuloMiniTesteResposta = async (dados) => {
    const response = await authenticatedFetch(URLS.UPDATE_MODULO_MINI_TESTE_RESPOSTA, {
      method: 'POST',
      body: JSON.stringify(dados),
    });
    return response.json();
  };

  const deletarModuloMiniTesteResposta = async (id) => {
    const response = await authenticatedFetch(URLS.DELETE_MODULO_MINI_TESTE_RESPOSTA, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });
    return response.json();
  };

  const listarModuloMiniTesteRespostas = async (filtros = {}) => {
    const response = await authenticatedFetch(URLS.GET_MODULO_MINI_TESTE_RESPOSTAS, {
      method: 'POST',
      body: JSON.stringify(filtros),
    });
    return response.json();
  };

  const obterModuloMiniTesteRespostaPorId = async (id) => {
    const response = await authenticatedFetch(URLS.GET_MODULO_MINI_TESTE_RESPOSTA_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });
    return response.json();
  };

  const listarModuloMiniTesteRespostasPorModulo = async (idModulo, idUsuario = null) => {
    const filtros = { idModulo };
    if (idUsuario) filtros.idUsuario = idUsuario;
    return listarModuloMiniTesteRespostas(filtros);
  };

  return {
    criarModuloMiniTesteResposta,
    atualizarModuloMiniTesteResposta,
    deletarModuloMiniTesteResposta,
    listarModuloMiniTesteRespostas,
    listarModuloMiniTesteRespostasPorModulo,
    obterModuloMiniTesteRespostaPorId,
  };
}
